import { render, staticRenderFns } from "./XtendAlertsDetails.vue?vue&type=template&id=65d0d3ee&scoped=true&"
import script from "./XtendAlertsDetails.vue?vue&type=script&lang=js&"
export * from "./XtendAlertsDetails.vue?vue&type=script&lang=js&"
import style0 from "./XtendAlertsDetails.vue?vue&type=style&index=0&id=65d0d3ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0d3ee",
  null
  
)

export default component.exports